import * as React from 'react'

function IconRectangleBlocked({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={98}
      height={144}
      viewBox="0 0 98 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter0_rectangle)">
            <path
              d="M83.301 144H14.7c0-8.052-6.584-14.584-14.699-14.584V14.584c8.115 0 14.699-6.532 14.699-14.584H83.3c0 8.052 6.584 14.584 14.699 14.584v114.832c-8.115 0-14.699 6.532-14.699 14.584z"
              fill="#A2A2A2"
            />
            <path
              d="M22.196 134.642c-2.445-5.679-7.04-10.238-12.764-12.664V22.049c5.724-2.426 10.319-6.985 12.764-12.664h53.609c2.445 5.679 7.04 10.238 12.764 12.664v99.929c-5.724 2.426-10.319 6.985-12.764 12.664H22.196z"
              stroke="#fff"
              strokeWidth={0.75}
              strokeMiterlimit={10}
            />
            <path
              d="M35.188 57.455l27.857 28.529M63.045 57.455L35.188 85.984"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_rectangle"
              x={0}
              y={0}
              width={98}
              height={144}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M82.601 143H15.4c0-7.94-6.45-14.381-14.399-14.381V15.381C8.95 15.381 15.399 8.94 15.399 1H82.6c0 7.94 6.45 14.381 14.399 14.381V128.62c-7.95 0-14.399 6.441-14.399 14.381z"
            fill="#fff"
          />
          <path
            d="M82.601 143H15.4c0-7.94-6.45-14.381-14.399-14.381V15.381C8.95 15.381 15.399 8.94 15.399 1H82.6c0 7.94 6.45 14.381 14.399 14.381V128.62c-7.95 0-14.399 6.441-14.399 14.381z"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M22.743 133.772a23.789 23.789 0 00-12.503-12.489v-98.54a23.786 23.786 0 0012.503-12.488h52.515A23.786 23.786 0 0087.76 22.743v98.54a23.789 23.789 0 00-12.503 12.489H22.743z"
            fill="#A2A2A2"
          />
          <path
            d="M35.47 57.657L62.758 85.79M62.758 57.657L35.47 85.79"
            stroke="#fff"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRectangleBlocked
